export default {
  /* Available States */
  AVAILABLE: 'Available',
  NOT_YET_AVAILABLE: 'Not Yet Available',

  /* In Progress States */
  IN_PROGRESS: 'In Progress',
  FAILURE: 'Failure',
  HALTED: 'Halted',
  PENDING: 'Pending',

  /* Completed States */
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  ERROR: 'Error',
  NOT_REQUIRED: 'Not Required',

  /* Workflow Names */
  DIVIDE: 'AuditBoundaries',
  METADATA_AUDIT: 'AuditCoverages',
  IMAGE_METADATA_AUDIT: 'ImageMetadataAudit',
  IMAGE_QUALITY_AUDIT: 'ImageQualityAudit',
}
